

function getConfigFB(){
    if (window.location.hostname === 'dev-points.serban.pw' ||
                    window.location.hostname === 'localhost'){
        return {
            apiKey: "AIzaSyDoBXzaETzAfCLayzn0Ac3JeSUNo_kAj78",
            authDomain: "dev-points-o.firebaseapp.com",
            databaseURL: "https://dev-points-o.firebaseio.com",
            projectId: "dev-points-o",
            storageBucket: "dev-points-o.appspot.com",
            messagingSenderId: "1087748972978"
            };
        }
    if (window.location.hostname === 'points-o-rama.serban.pw'){
        return{
            apiKey: "AIzaSyDNd_2t-FgMiMy2_RiyjOB0uIY7RsZLdWw",
            authDomain: "points-o-rama.firebaseapp.com",
            databaseURL: "https://points-o-rama.firebaseio.com",
            projectId: "points-o-rama",
            storageBucket: "points-o-rama.appspot.com",
            messagingSenderId: "825315928839"
        }
    }
    return null;
}

export default getConfigFB;


// WEBPACK FOOTER //
// ./src/helpers/ConfigFB.js